import { useEffect, useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToSection } from "@/lib/scroll";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Savings", href: "#savings" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    scrollToSection(href);
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow] duration-300 ${
        scrolled
          ? "bg-[#FAF9F5]/85 backdrop-blur-md border-b border-[#0F1E19]/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between">
        <button onClick={() => go("#top")} className="focus:outline-none" data-testid="nav-logo-btn">
          <Logo />
        </button>
        <nav className="hidden lg:flex items-center gap-8" data-testid="nav-links">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="text-sm font-medium text-[#4A5D55] hover:text-[#0A3B2C] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div className="hidden lg:block">
          <button
            data-testid="nav-book-consultation-btn"
            onClick={() => go("#contact")}
            className="group inline-flex items-center gap-2 rounded-full bg-[#0A3B2C] px-5 py-2.5 text-sm font-semibold text-[#FAF9F5] transition-all hover:bg-[#072B20]"
          >
            Book a Free Consultation
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
          </button>
        </div>
        <button
          className="lg:hidden p-2 text-[#0F1E19]"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden bg-[#FAF9F5]/95 backdrop-blur-md border-b border-[#0F1E19]/10" data-testid="nav-mobile-menu">
          <div className="px-6 py-4 flex flex-col gap-4">
            {LINKS.map((l) => (
              <button
                key={l.href}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                onClick={() => go(l.href)}
                className="text-left text-base font-medium text-[#0F1E19]"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-mobile-book-btn"
              onClick={() => go("#contact")}
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-[#0A3B2C] px-5 py-3 text-sm font-semibold text-[#FAF9F5]"
            >
              Book a Free Consultation
              <ArrowRight className="h-4 w-4" />
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
